import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {Button} from '@learningblocks/shared-components';

export function ModalViewControls(props) {

  const {t} = useTranslation();

  const views  = {
    TOP_VIEW: {
      view: t("TopView.string"),
      description: "1. Choose a lane"
    },
    SIDE_VIEW: {
      view: t("SideView.string"),
      description: "2. Dispense liquid"
    }
  };
  
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick();
  };

  return (
    <div className={`viewControls`}>
      {props.views.map(view => {
        return(
          <Button
            class={(props.currentView == Object.keys(view)[0])?"active":"primary"}
            disabled={(
              props.currentView === "TOP_VIEW" &&
              props.selectedLane === null &&
              Object.keys(view)[0] === "SIDE_VIEW"
            )}
            onClick={()=>props.setCurrentView(Object.keys(view)[0])}
          >
            <>
              <p>{views[view[Object.keys(view)[0]]].view}</p>
              <p>{views[view[Object.keys(view)[0]]].description}</p>
            </>
          </Button>
        )
      })}
    </div>
  );
}

ModalViewControls.propTypes = {
  /**
   * ClassName to set on ModalViewControls
   */
  className: PropTypes.string,
  /**
   * List of views
   */
  views: PropTypes.string,
  /**
   * Function to set the current view
   */
  setCurrentView: PropTypes.func,
  /**
   * The current view string
   */
  currentView: PropTypes.string,
};

ModalViewControls.defaultProps = {
    disabled: false
};
